import React, {useContext} from 'react';
import {Logo} from 'bonprix-design-system';
import {HeaderContext} from '@header/scripts/components/context/HeaderContext.jsx';
import LandmarkAdapter from '@core/scripts/components/landmark-adapter.js';

export default function HeaderLogo({rootUrl}) {
    const {headerLightMode} = useContext(HeaderContext);
    const logoVariant = headerLightMode ? 'bonprix-negative' : 'bonprix-positive';

    const handleClick = () => {
        LandmarkAdapter.sendClickLandmark('logo');
    };

    return (
        <a className="header__bp-logo" href={rootUrl} title="bonprix" onClick={handleClick}>
            <Logo variant={logoVariant} className="logo-img" />
        </a>
    );
}
